import { render, staticRenderFns } from "./InventoryEquipment.vue?vue&type=template&id=80938c6c"
import script from "./InventoryEquipment.vue?vue&type=script&lang=js"
export * from "./InventoryEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports